module.exports = __webpack_public_path__ + "static/media/layout_report.6944a79f.png";